import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { CompanyPostApiClient, People } from '~/services/Http';

export const GET_COMPANY_POSTS_SWR_KEY = 'CompanyPostApiClient.getCompanyPosts';

export function useGetCompanyPosts(args?: {
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order21;
  statuses?: People.CompanyPostStatusEnum[];
}): UseSWROutput<People.CompanyPostDto[]> {
  return useSWR(
    [
      GET_COMPANY_POSTS_SWR_KEY,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.statuses ?? undefined,
    ],
    ([_, lang, offset, limit, order, statuses]) =>
      CompanyPostApiClient.getCompanyPosts(
        order,
        offset,
        limit,
        lang,
        statuses,
      ).then((r) => r.data),
  );
}
